import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalMathProgressBars from './ModalMathProgressBars';

const numberOfMathProgressBars = '3';

function ModalMathIntensity(props) {
  const { t } = useTranslation();
  const { mathIntensity } = { ...props };

  return (
    <div className="modal-math-intensity-container">
      <p className="modal-math-intensity copy-text">
        {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
        {t('Math Intensity')}:
      </p>
      <div>
        <ModalMathProgressBars
          numBars={numberOfMathProgressBars}
          barsFilled={mathIntensity}
          tenant={props.tenant}
        />
        <p className="modal-math-intensity-value-description">
          {t(`{{value}}/{{maximumValue}}`, {
            value: mathIntensity,
            maximumValue: numberOfMathProgressBars,
          })}
        </p>
      </div>
    </div>
  );
}

export default ModalMathIntensity;
